import { render, staticRenderFns } from "./AssetLayout.vue?vue&type=template&id=3c311fde&scoped=true"
import script from "./AssetLayout.vue?vue&type=script&lang=js"
export * from "./AssetLayout.vue?vue&type=script&lang=js"
import style0 from "./AssetLayout.vue?vue&type=style&index=0&id=3c311fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c311fde",
  null
  
)

export default component.exports